import { useCallback } from 'react';
import _ from 'lodash';

import { CURRENT_CLIENT_IDENTIFIER, CURRENT_USER_IDENTIFIER, PermissionAction } from '../../models/permission.models';
import { useMe } from '../useMe';

export interface UseCheckPermissionsArgs {}

export function useCheckPermission() {
  const { currentUser, currentClient, isLoading } = useMe();

  const can = useCallback(
    <ResourceType extends object>(action: PermissionAction, resource?: ResourceType) => {
      const permissions = currentUser?.permissions || [];

      const policy = permissions.find((policy) => policy.action === action);

      if (!policy) return false;

      if (policy.conditions) {
        if (!resource) return false;

        return policy.conditions.every((condition) => {
          const actualValue = _.get(resource, condition.field);

          const getExpectedValue = () => {
            if (condition.value === CURRENT_USER_IDENTIFIER) {
              return currentUser?.id;
            }

            if (condition.value === CURRENT_CLIENT_IDENTIFIER) {
              return currentClient?.id;
            }
          };
          const expectedValue = getExpectedValue();

          if (condition.operator === 'equal') {
            return actualValue === expectedValue;
          }

          return undefined;
        });
      }

      return true;
    },
    [currentUser, currentClient],
  );

  return {
    can,
    isLoading,
  };
}
